<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        :disabled="disabledRed"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Faltosos
      <!-- <span v-b-tooltip.hover title="Faltosos para as vacinas polio ou penta" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span> -->
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        :disabled="disabledGreen"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Em dias
      <!-- <span v-b-tooltip.hover title="Com vacinas polio e penta em dias" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span> -->
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="blacks"
        :disabled="disabledBlack"
        @change="onChangeBlacks($event)"
      />
      <!-- <span class="black"></span>  -->
      Transcrição
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: () => {},
    },
    disabledRed: {
      type: Boolean,
    },
    disabledGreen: {
      type: Boolean,
    },
    disabledBlack: {
      type: Boolean,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
      blacks: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$emit('resetarNome', this.setRed)
          this.greens = false
          this.blacks = false
          this.reds = true
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.blacks = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.blacks = false
      this.$emit('exibirVerdes', event.target.checked)
    },
    onChangeBlacks(event) {
      this.greens = false
      this.reds = false
      this.$emit('exibirPretos', event.target.checked)
    },
  },
}
</script>

<style>
.subtitle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.subtitle-item {
  font-size: 13px;
  margin: 25px 10px;
}
.subtitle-item span {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
}

.subtitle-item span i {
  font-size: 14px;
  vertical-align: top;
}
/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}
</style>

<style scoped>
.subtitle-item .red {
  border: 1px solid rgb(235 64 52 / 30%);
  box-shadow: 0 5px 1px 0 rgb(235 64 52 / 80%),
    0 12px 90px 0 rgb(235 64 52 / 1%);
  margin-top: -5px;
  width: 25px;
  border-radius: 15px;
}
.subtitle-item .green {
  border: 1px solid rgb(0 128 0 / 30%);
  box-shadow: 0 5px 1px 0 rgb(0 128 0 / 80%), 0 12px 90px 0 rgb(0 128 0 / 1%);
  margin-top: -5px;
  width: 25px;
  border-radius: 15px;
}

.subtitle-item .black {
  border: 1px solid rgb(0 0 0 / 30%);
  box-shadow: 0 5px 1px 0 rgb(0 0 0 / 80%), 0 12px 90px 0 rgb(0 0 0 / 1%);
  margin-top: -5px;
  width: 25px;
  border-radius: 15px;
}
</style>
